import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Table } from '../../index.js';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Meta } from './style.js';
export const WorkflowDetails = (props) => {
    const lang = useSelector((s) => s.lang);
    const [showWorkflowOpen, setShowWorkflowOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: showWorkflowOpen, onOpen: () => setShowWorkflowOpen(true), onClose: () => setShowWorkflowOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                props.details.workflowTitle && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.workflow)),
                    React.createElement("td", null, props.details.workflowTitle))),
                props.details.label && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.label)),
                    React.createElement("td", null, lang.updateTypes[props.details.updateTypeId] ||
                        props.details.label))),
                props.details.description && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.description)),
                    React.createElement("td", null, props.details.description))),
                props.details.update && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.note)),
                    React.createElement("td", null, props.details.update))),
                props.details.createdAt && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.blameLogs.createdAt)),
                    React.createElement("td", null, moment(props.details.createdAt).format(THEME.DATE_FORMAT_LONG)))),
                props.details.actionType && (React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("b", null, lang.bulkActions.bulkActions)),
                    React.createElement("td", null, props.details.actionType in lang.bulkActionTypes
                        ? // @ts-ignore
                            lang.bulkActionTypes[props.details.actionType]
                        : props.details.actionType)))))));
};
//# sourceMappingURL=WorkflowDetails.js.map